export default "__VITE_ASSET__SnH21ePJ__"